import { useState, useEffect, useCallback } from "react";

export default function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
  const close = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const handleActivity = () => {
      setIsVisible(true);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setIsVisible(false), 8000);
    };

    window.addEventListener("mousemove", handleActivity, { passive: true });
    window.addEventListener("scroll", handleActivity, { passive: true });
    window.addEventListener("touchstart", handleActivity, { passive: true });

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("scroll", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div
      className={`fixed right-4 bottom-20 z-50 md:hidden transition-all duration-500 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      {/* Toggle button */}
      <button
        type="button"
        onClick={toggle}
        className="w-14 h-14 flex items-center justify-center bg-primary-500 text-background-50 rounded-full shadow-lg hover:bg-primary-600 transition-colors"
        aria-label={isOpen ? "Kontakt schließen" : "Kontakt öffnen"}
      >
        {isOpen ? (
          <i className="ri-close-line w-6 h-6 flex items-center justify-center text-xl"></i>
        ) : (
          <i className="ri-customer-service-line w-6 h-6 flex items-center justify-center text-xl"></i>
        )}
      </button>

      {/* Action buttons panel */}
      {isOpen && (
        <div className="absolute right-0 bottom-16 flex flex-col items-end gap-3">
          {/* Phone */}
          <a
            href="tel:+494914238"
            onClick={close}
            className="flex items-center gap-3 group"
          >
            <span className="text-sm font-medium text-foreground-700 bg-background-50 px-3 py-1.5 rounded-md shadow-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
              0491 4238
            </span>
            <div className="w-12 h-12 flex items-center justify-center bg-primary-500 text-background-50 rounded-full shadow-md hover:bg-primary-600 transition-colors">
              <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-lg"></i>
            </div>
          </a>

          {/* Email */}
          <a
            href="mailto:info@blumen-stoehr.de"
            onClick={close}
            className="flex items-center gap-3 group"
          >
            <span className="text-sm font-medium text-foreground-700 bg-background-50 px-3 py-1.5 rounded-md shadow-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
              info@blumen-stoehr.de
            </span>
            <div className="w-12 h-12 flex items-center justify-center bg-secondary-500 text-background-50 rounded-full shadow-md hover:bg-secondary-600 transition-colors">
              <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-lg"></i>
            </div>
          </a>
        </div>
      )}
    </div>
  );
}